import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { apiurl } from "@/Config/ApiConfig/ApiUrl";

export const forgotpasswordApi = createApi({
  reducerPath: "forgotpasswordApi",
  baseQuery: fetchBaseQuery({ baseUrl: import.meta.env.VITE_BASE_API_URL }),
  tagTypes: ["Forgotpassword"],
  endpoints: (builder) => ({
    forgotPassword: builder.mutation({
      query: (username) => ({
        url: apiurl.ForgotPassword, // e.g. "/forgotPassword"
        method: "POST",
        body: { userName: username }, // 🔑 backend expects "userName"
        headers: {
          "X-Request-Id": Math.random().toString(36).substring(2), // unique request ID
        },
      }),
      transformResponse: (response) => {
        return response?.data ?? null;
      },
      invalidatesTags: ["Forgotpassword"],
    }),
  }),
});

export const { useForgotPasswordMutation } = forgotpasswordApi;
